import { AlertTriangle, Info, FlaskConical } from 'lucide-react';
import { avisoDeLicencia, avisoDeActualizacion } from './licencia';

// EL AVISO DE LA LICENCIA, EN TODAS LAS PANTALLAS · Bloque 3.
//
// Existía ya, y solo en «Ajustes → Este servidor». El criterio del bloque
// dice que **las pantallas** digan en palabras qué pasa con la licencia y
// las actualizaciones y hasta cuándo — en plural, y por un motivo
// concreto: el día que TEGO pasa a modo consulta, quien se entera no es
// el dueño mirando ajustes, es la persona del andén que aprieta
// «Guardar». Enterarse por un error es exactamente lo que la Doctrina 2
// llama regañar en vez de prevenir.
//
// VA ARRIBA Y NO SE PUEDE CERRAR. Un aviso que se descarta con una X se
// descarta el primer día y ya no vuelve a verse nunca; este solo
// desaparece cuando desaparece el motivo.
export default function AvisoLicencia({ licencia, actualizacion, empresa }) {
  const aviso = avisoDeLicencia(licencia);
  const nueva = avisoDeActualizacion(actualizacion);
  const ejemplo = Boolean(empresa?.es_ejemplo);
  if (!aviso && !nueva && !ejemplo) return null;

  return (
    <>
      {/* LA EMPRESA DE EJEMPLO VA PRIMERA · criterio 4.3. Enterarse de
          que los datos son inventados DESPUÉS de haber decidido algo con
          ellos es peor que no tener demo. */}
      {ejemplo && (
        <div
          role="status"
          className="flex items-start gap-2 border-b border-purple-300
                     bg-purple-100 px-4 py-2 text-xs text-purple-900"
        >
          <FlaskConical className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
          <span>
            <span className="font-semibold">Empresa de ejemplo.</span>{' '}
            Todo lo que ves aquí es inventado y sirve para enseñar TEGO.
            Ninguno de estos productos, movimientos ni precios es real.
          </span>
        </div>
      )}
      {aviso && (
        <div
          role="alert"
          className={`flex items-start gap-2 px-4 py-2 text-xs ${
            aviso.tono === 'problema'
              ? 'bg-red-700 text-white'
              : 'bg-amber-100 text-amber-900 border-b border-amber-300'
          }`}
        >
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
          <span>
            <span className="font-semibold">{aviso.titulo}.</span>{' '}
            {aviso.mensaje} {aviso.queHacer}
          </span>
        </div>
      )}
      {nueva && (
        <div
          role="status"
          className="flex items-start gap-2 border-b border-gray-200 bg-gray-50
                     px-4 py-2 text-xs text-gray-700"
        >
          <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
          <span>{nueva}</span>
        </div>
      )}
    </>
  );
}
